
import { ApiKeys, EndPoints } from '@/keys';
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';

import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});
Vue.filter('formatLastLogin', function(value) {
  if (value) {
    return moment(String(value)).format('hh:mm a MMM DD, YYYY')
  }
});
Vue.filter('formatMessageTime', function(value) {
  if (value) {
    return moment(String(value)).format('hh:mm a')
  }
});

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


import vSelect from 'vue-select'
 
Vue.component('v-select', vSelect)

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = ApiKeys.BASE_URL;
// Vue.axios.defaults.baseURL = 'http://192.168.0.51:3000';
Vue.router = router;

var user = {};
var token = '';
Vue.use(require('@websanova/vue-auth'), {
  auth: {
      request: function (req, token) {
        this.options.http._setHeaders.call(this, req, {Authorization: 'bearer '+token});
    },
    
    response: function (res) {
      if(res.data.data)
      {
        user = res.data.data.data;
      // window.localStorage.setItem('token',res.data.token);
      // window.token = res.data.token;
        return res.data.data.token
      }
      else return null
    }

  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),

  loginData: {
    fetchUser: false
  },

  fetchData: {
      enabled: false,
      success: function () {
          // token = Vue.auth.token();
          Vue.auth.user(user);
      }
  },
  refreshData: false,
  authRedirect: {path: '/admin/login'},
  //forbiddenRedirect: {path: '/403'}---will forbid specifc role
  notFoundRedirect: { path: '/' }
})

// console.log('token after login is: ',token);
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage);



axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
  if(error.response){
      if(error.response.status == 401 && error.response.statusText == 'Unauthorized'){
        Vue.auth.logout({
            redirect: '/admin/login',
            makeRequest: false
        });
    }
  }
  return Promise.reject(error);
});


import Toasted from 'vue-toasted';
 
Vue.use(Toasted)

import VueGlobalVar from 'vue-global-var';

Vue.use(VueGlobalVar, {
  globals: {
    $axios: axios,
    $ApiKeys: ApiKeys,
    $EndPoints: EndPoints,
    $maxFileSize: 1,
    $photoFormats: ['jpeg','jpg','png','gif']
  },
});

var userr = JSON.parse(Vue.localStorage.get('user'));
store.commit('updateUserType', userr ? userr.user_type : 'admin');

Vue.mixin({
  data: function() {
    return {
      toggleGroup: true
    }
  }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
